import React, { Component } from 'react';
import './Card.css';

class Card extends Component {

constructor(props) {
  super(props);

  if(this.props.type === 'industrialIoT') {
    this.myTitle = "Industrial IoT";
    this.myText = "Whether your company is in manufacturing, oil and gas, environmental, retail, logistics, or a different industry, from front office to shop floor, we provide monitoring and control solutions that drive business. We deliver essential data to decision makers in near real time, maximizing your bottom line. ";
    this.icon = 'fas fa-industry'
  } else if (props.type === 'IoTProduct') {
    this.myTitle = "Connected Products";
    this.myText = "Need help with your connected products or devices? Let us create a smooth, secure, and interactive web based front end for your internet connected products. We create web based control panels for IoT devices that are highly functional, interactive, and intuitive. From sensor, to cloud, to client, we are your complete end to end solution."
    this.icon = 'fas fa-cloud'
  } else if (props.type === 'modernWebsites') {
    this.myTitle = "Modern Websites";
    this.myText = "Need an awesome website for your product or business? Great! We do that. Featuring the very latest in web technologies, we create engaging and interactive user experiences for our customers' products and services, that sell. We also specialize in maintaining, updating, and reworking existing websites and applications.";
    this.icon = 'fas fa-desktop'
  }
}

  render() {
    return (
        <div className='card'>
          <div className='icon'>
            <i className={this.icon}></i>
          </div>

          <div className = "title">{this.myTitle}</div>
          {this.myText}
        </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/Components/Card/Card.js